import { render, staticRenderFns } from "./TaskChatflowDialog.vue?vue&type=template&id=2bd17475"
import script from "./TaskChatflowDialog.vue?vue&type=script&lang=js"
export * from "./TaskChatflowDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports